import { forwardRef } from '@chakra-ui/react';

import { ButtonGroup, type ButtonGroupProps } from '@frontend/components';

export type ModalButtonGroupProps = ButtonGroupProps;

export const ModalButtonGroup = forwardRef<ModalButtonGroupProps, 'div'>(
  ({ size = 'lg', justifyContent = 'end', ...restProps }, ref) => {
    return (
      <ButtonGroup
        ref={ref}
        size={size}
        justifyContent={justifyContent}
        {...restProps}
      />
    );
  },
);
ModalButtonGroup.displayName = 'ModalButtonGroup';
